var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackspaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.101,
    height: 12.25,
    viewBox: "0 0 16.101 12.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13679",
    "data-name": "Group 13679",
    transform: "translate(9335.642 -3729.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-backspace",
    "data-name": "Icon material-backspace",
    d: "M13.75,4.5H4.375a1.176,1.176,0,0,0-.994.55L0,10.125l3.381,5.069a1.182,1.182,0,0,0,.994.556H13.75A1.254,1.254,0,0,0,15,14.5V5.75A1.254,1.254,0,0,0,13.75,4.5Z",
    transform: "translate(-9335.041 3725.5)",
    fill: "none",
    stroke: "#2eafbe",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x2: 6,
    transform: "translate(-9328.621 3733.504) rotate(45)",
    fill: "none",
    stroke: "#2eafbe",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    y2: 6,
    transform: "translate(-9324.379 3733.504) rotate(45)",
    fill: "none",
    stroke: "#2eafbe",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspaceIcon);
export default __webpack_public_path__ + "static/media/backspace-icon.4039c22efc0316ff08a8ed64a6008ae8.svg";
export { ForwardRef as ReactComponent };